import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class BotidService {
  private botid: string = '';

  public getBotId(): string {
    return this.botid;
  }

  public setBotId(id: string): void {
    this.botid = id;
  }
}
